import { FC } from "react";
import { cn } from "./cn";

const SIZE = { sm: "w-4 h-4 border-2", md: "w-5 h-5 border-2", lg: "w-8 h-8 border-[3px]" };

export const Spinner: FC<{ size?: keyof typeof SIZE; className?: string }> = ({
  size = "md",
  className,
}) => (
  <span
    role="status"
    aria-label="Loading"
    className={cn(
      "inline-block rounded-full border-accent/30 border-t-accent animate-spin",
      SIZE[size],
      className
    )}
  />
);
